




































































import HeaderMenuList from "@/components/HeaderMenuList/HeaderMenuList.vue";
import { IUserLanguageData } from "@/models/interfaces/session";
import { UserLanguage } from "@/models/types/session";

import { Vue, Component } from "vue-property-decorator";
import { Action, Mutation } from "vuex-class";

@Component({
  components: {
    HeaderMenuList
  }
})
export default class HeaderLanguageMenu extends Vue {
  @Action("session/changeUserLanguage")
  private changeUserLanguage!: (locale: UserLanguage) => Promise<any>;

  @Mutation("session/setUserLanguages")
  private setUserLanguages!: (data: Partial<IUserLanguageData>) => void;

  public onLangChange(name: UserLanguage) {
    this.changeUserLanguage(name);
    this.$root.$i18n.locale = name;

    this.setUserLanguages({
      supportLanguage: name
    });
  }
}
